<template>
    <div class="reset-password">
        <div class="header">
            <div class="header-content">
                <div class="logo" @click="goSigleLogin">
                    <img src="static/lg.png" />
                </div>
            </div>
        </div>
        <div class="passReset">
            <div class="reset-wrap">
                <div class="reset-title">重置密码</div>
                <div class="reset-form">
                    <div class="pWLeft">
                        <el-form
                            :label-position="labelPosition"
                            label-width="100px"
                            :model="passSetForm"
                            ref="passSetForm"
                            :rules="rules"
                        >
                            <el-form-item label="账号：" prop="uid">
                                <el-input
                                    type="text"
                                    size="medium"
                                    placeholder="请输入账号"
                                    v-model.trim="passSetForm.uid"
                                    auto-complete="off"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="旧密码：" prop="oldPassWord">
                                <el-input
                                    type="password"
                                    size="medium"
                                    @blur="oldPswdBlur"
                                    placeholder="请输入旧密码"
                                    v-model.trim="passSetForm.oldPassWord"
                                    auto-complete="off"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="新密码：" prop="newPassWord">
                                <el-input
                                    type="password"
                                    @keyup.native="cipher"
                                    size="medium"
                                    placeholder="请输入新密码"
                                    v-model.trim="passSetForm.newPassWord"
                                    auto-complete="off"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="重复新密码：" prop="repeatPassWord">
                                <el-input
                                    type="password"
                                    size="medium"
                                    placeholder="请重复输入新密码"
                                    v-model.trim="passSetForm.repeatPassWord"
                                    auto-complete="off"
                                ></el-input>
                            </el-form-item>
                            <div
                                class="stateCantent"
                                v-show="passSetForm.newPassWord != '' || passSetForm.repeatPassWord != ''"
                            >
                                <span
                                    style="font-size:14px;padding-left:15px;"
                                    v-show="passSetForm.newPassWord != '' || passSetForm.repeatPassWord != ''"
                                >安全等级</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                <span class="passState" :style="{color: passState.status == 'low' ? '#fe5624' : passState.status == 'middle' ? '#3ba2e9' : passState.status == 'strong' ? '#80cd6e' : ''}"
                                >{{passState.state || '低'}}</span>
                                <div class="stateBar">
                                    <transition name="fade">
                                        <div
                                            :class="{
                                            stateLow: passState.status == 'low',
                                            stateMiddle: passState.status == 'middle',
                                            stateStrong : passState.status == 'strong'}"
                                        ></div>
                                    </transition>
                                </div>
                            </div>
                            <el-form-item style="margin-top:20px;">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="submitForm('passSetForm')"
                                >提交</el-button>
                                <el-button type="text" @click="resetForm('passSetForm')">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="pWRight">
                        <p>1. 长度8-16位字符</p>
                        <p>2. 不能包含空格</p>
                        <p>3. 必须包含数字、小写字母、大写字母、特殊字符（!&lt;&gt;%&amp;_+¥除外）</p>
                        <p>4. 不能包含账号</p>
                        <p>5. 不能使用前5次历史密码</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <p class="link">
                <a href="javascript:;">服务条款</a>
                <a href="javascript:;">隐私政策</a>
                <a href="javascript:;">联系我们</a>
                <a href="javascript:;">投诉中心</a>
            </p>
        </div>
    </div>
</template>

<script>
import cipher from "../utils/strengthCipher";
import http from "../utils/httpClient";
export default {
    name: "ResetPassword",
    data() {
        var validateOldPswd = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入旧密码"));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") callback(new Error("请输入密码"));
            else if (value.length < 8 || value.length > 16) {
                callback(new Error("长度需在 8 到 16 个字符"));
            } else if (value.match(/\s/g)) {
                callback(new Error("不能包含空格"));
            } else if (value == this.passSetForm.oldPassWord) {
                callback(new Error("不能与原密码相同"));
            } else if (
                this.passSetForm.uid &&
                value.indexOf(this.passSetForm.uid) != -1
            ) {
                callback(new Error("不能包含账号"));
            } else if (
                !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~@#$^*()\-=\[{}\]\\|:;"',.?/])[\w`~@#$^*()\-=\[{}\]\\|:;"',.?/]{8,16}/.test(
                    value
                )
            ) {
                callback(new Error("必须包含字母、数字、特殊字符"));
            } else {
                if (this.passSetForm.repeatPassWord !== "")
                    this.$refs.passSetForm.validateField("repeatPassWord");
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") callback(new Error("请再次输入密码"));
            else if (value !== this.passSetForm.newPassWord)
                callback(new Error("两次输入密码不一致!"));
            else callback();
        };
        return {
            passSetForm: {
                uid: "",
                oldPassWord: "",
                newPassWord: "",
                repeatPassWord: ""
            },
            labelPosition: "right",
            rules: {
                uid: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }
                ],
                oldPassWord: [
                    {
                        required: true,
                        validator: validateOldPswd,
                        trigger: "blur"
                    }
                ],
                newPassWord: [
                    {
                        required: true,
                        validator: validatePass,
                        trigger: "blur"
                    }
                ],
                repeatPassWord: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigger: "blur"
                    }
                ]
            },
            passState: {
                status: ""
            }
        };
    },
    methods: {
        cipher() {
            this.passState = cipher.validate(this.passSetForm.newPassWord);
        },
        oldPswdBlur() {},
        // 点logo去首页
        goSigleLogin () {
            window.location.href = `${process.env.SSO}/logout?service=${process.env.Login_OUT}`;
        },
        // 提交钮事件
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    console.log("passSetForm---", this.passSetForm);
                    var params = {
                        uid: this.passSetForm.uid,
                        oldPassword: this.passSetForm.oldPassWord,
                        newPassword: this.passSetForm.newPassWord,
                        newPasswordVal: this.passSetForm.repeatPassWord
                    };
                    // 请求修改密码的接口
                    http.resetPost("/password/repair", params)
                        .then(res => {
                            if (res.head.responseCode == "0") {
                                this.$message.success(res.head.responseMessage);
                                // window.location.href = `${process.env.SSO}/logout?service=${process.env.Login_OUT}`;
                            } else {
                                this.$message.error(res.head.responseMessage);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err);
                        });
                } else {
                    return false;
                }
            });
        },
        // 取消按钮点击事件
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // this.$router.go(-1);
            window.location.href = `${process.env.SSO}/logout?service=${process.env.Login_OUT}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.reset-password {
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
        height: 60px;
        background: #292e41;
        border-bottom: 1px solid #ddd;
        overflow: hidden;
        padding: 0 20px;
        overflow: hidden;
        z-index: 10001;
        .header-content {
            width: 60%;
            margin: 0 auto;
            overflow: hidden;
            .logo {
                width: 180px;
                height: 60px;
                line-height: 56px;
                float: left;
                img {
                    width: 160px;
                    vertical-align: middle;
                    cursor: pointer;
                }
            }
        }
    }
    .reset-wrap {
        width: 60%;
        margin: 20px auto;
        background: #fff;
        padding: 0 20px 20px;
        border-radius: 5px;
        .reset-title {
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #eee;
            font-size: 14px;
        }
        .reset-form {
            display: flex;
            // align-items: center;
            justify-content: space-around;
            padding-top: 20px;
        }
    }

    .passReset {
        flex: 1;
        overflow-x: hidden;
        background: #F2F4F8;
        .el-button--primary {
            margin: 0;
        }
        .el-button--text {
            color: #333;
        }
        .pWLeft {
            width: 50%;
            .el-form {
                .stateCantent {
                    width: 100%;
                    height: 36px;
                    line-height: 36px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    margin-top: 10px;
                    padding-left: 30px;
                    font-size: 14px;
                    .passState {
                        display: inline-block;
                        min-width: 30px;
                    }
                    .stateBar {
                        flex: 1;
                        overflow: hidden;
                        float: left;
                        border-radius: 60px;
                        overflow: hidden;
                        background: #f2f2f2;
                        div {
                            height: 8px;
                        }
                        .fade-enter-active,
                        .fade-leave-active {
                            transition: all 0.3s ease-in;
                        }
                        .fade-enter,
                        .fade-leave-active {
                            opacity: 0;
                        }
                        .stateLow {
                            width: 33%;
                            background: #fe5624;
                            transition: all 0.7s ease-in;
                        }
                        .stateMiddle {
                            width: 66%;
                            background: #3ba2e9;
                            transition: all 0.7s ease-in;
                        }
                        .stateStrong {
                            width: 100%;
                            background: #80cd6e;
                            transition: all 0.7s ease-in;
                        }
                    }
                }
            }
        }
        .pWRight {
            float: right;
            border-left: 1px solid #efefef;
            margin-left: 50px;
            padding-left: 30px;
            p {
                font-size: 12px;
                padding-bottom: 16px;
                color: #999999;
            }
        }
    }

    .footer {
        width: 100%;
        background: #F2F4F8;
        height: 60px;
        .link,
        .copyright {
            width: 60%;
            margin: 0 auto;
            font-size: 12px;
            line-height: 30px;
            color: #fff;
            text-align: center;
        }
        .link > a {
            display: inline-block;
            height: 14px;
            line-height: 14px;
            padding: 0 30px;
            border-right: 1px solid #bbb;
            color: #666;
        }
        .link > a:last-child {
            border: none;
        }
        .link > a:hover {
            color: #4b84e0;
        }
        .copyright {
            width: 300px;color: #666;
        }
    }
}
/*手机*/
@media screen and (max-width :769px) {
    .reset-password {
        .reset-wrap{
            width: 90%;
            margin: 10px auto;
            padding: 0 10px;
            .reset-form {
                display: block;
            }
        }
        .passReset {
            
            .pWLeft {
                width: 100%;
            }
            .pWRight {
                float: none;
                border-left: none;
                margin: 10px;
                padding: 0;
            }
        }
        /deep/ .el-form-item__label {
            padding: 0!important;
        }
        /deep/ .el-input-group__append {
          padding: 0 10px;
        }
        .footer {
            height: 36px;
            .link {
                width: 100%;
                a {
                    padding: 0 10px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue